import { PROPERTIES, getProperty } from './properties';

const builtinIds = new Set(PROPERTIES.map((property) => property.id));

export const isBuiltinProperty = (id) => builtinIds.has(id);

export const registryProperties = () => [];

export const registryProperty = (actorId, propertyId) => (
    registryProperties(actorId).find((property) => property.id === propertyId) || null
);

export const resolveProperty = (actorId, propertyId, actorProperties = []) => (
    getProperty(propertyId)
    || actorProperties.find((property) => property.id === propertyId)
    || registryProperty(actorId, propertyId)
);

export const propertiesForActor = (actor) => {
    const extras = [];
    const seen = new Set(builtinIds);

    const add = (property) => {
        if (!property?.id || seen.has(property.id)) return;
        seen.add(property.id);
        extras.push(property);
    };

    (actor?.properties || []).forEach(add);
    registryProperties(actor?.id).forEach(add);
    return [...PROPERTIES, ...extras];
};

export const customPropertyIds = (clip, actorId) => {
    const actor = clip?.actors?.find((item) => item.id === actorId);
    const ids = new Set();
    (actor?.properties || []).forEach((property) => ids.add(property.id));
    registryProperties(actorId).forEach((property) => ids.add(property.id));
    (clip?.tracks || []).forEach((track) => {
        if (track.actorId === actorId && !builtinIds.has(track.property)) ids.add(track.property);
    });
    return [...ids];
};
